import { getDecimalSeparator } from '@finbeat/react-toolkit';

export const numberFromLocaleString = (value: string, locale: string) => {
    const decimalSeparator = getDecimalSeparator(locale);
    const [integerPart, decimalPart] = value.split(decimalSeparator);

    if (decimalPart) {
        return (
            parseFloat(integerPart.replace(/\D/g, '')) +
            parseFloat(decimalPart) / Math.pow(10, decimalPart.length)
        );
    }

    return parseFloat(value.replace(/\D/g, ''));
};
